<template>
  <div class="animated fadeIn">
    <div class="ops container-custom">
      <div class="ops__wrapper">
        <div class="ops__header">
          <div class="ops__title" id="traffic">Reports</div>
          <div class="reports__button">
            <div class="reports__button__item" @click.preventDefault="getDataAsCSV">
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18"><defs><linearGradient id="j498a" x1="0" x2="16.71" y1="18" y2="18" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#941abd"/><stop offset=".49" stop-color="#f61f7e"/><stop offset="1" stop-color="#fea478"/></linearGradient><linearGradient id="j498b" x1="4.51" x2="12.21" y1="15.43" y2="15.43" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#941abd"/><stop offset=".49" stop-color="#f61f7e"/><stop offset="1" stop-color="#fea478"/></linearGradient></defs><g><g><g><g><g><path fill="url(#j498a)" d="M16.071 11.57a.643.643 0 0 0-.642.643v3.857a.643.643 0 0 1-.643.643H1.929a.643.643 0 0 1-.643-.643v-3.857a.643.643 0 1 0-1.286 0v3.857c0 1.065.863 1.929 1.929 1.929h12.857a1.929 1.929 0 0 0 1.928-1.929v-3.857a.643.643 0 0 0-.643-.643z"/></g></g></g><g><g><g><path fill="url(#j498b)" d="M12.014 11.117a.643.643 0 0 0-.894 0l-2.118 2.117V.643a.643.643 0 1 0-1.286 0v12.59L5.6 11.118a.643.643 0 0 0-.909.909l3.215 3.214a.643.643 0 0 0 .91 0l3.214-3.214a.643.643 0 0 0-.015-.91z"/></g></g></g></g></g></svg>
              Download
            </div>
            <div class="reports__button__item" @click.preventDefault="uploadDialog = true">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><defs><linearGradient id="yh9ya" x1="0" x2="18" y1="12.85" y2="12.85" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#941abd"/><stop offset=".49" stop-color="#f61f7e"/><stop offset="1" stop-color="#fea478"/></linearGradient><linearGradient id="yh9yb" x1="5.79" x2="13.49" y1="18" y2="18" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#941abd"/><stop offset=".49" stop-color="#f61f7e"/><stop offset="1" stop-color="#fea478"/></linearGradient></defs><g><g><g><g><g><path fill="url(#yh9ya)" d="M16.633 6.049c.056-.3.084-.606.085-.912A5.143 5.143 0 0 0 6.739 3.39a2.572 2.572 0 0 0-3.452 1.79 3.857 3.857 0 0 0 .573 7.672h3.214a.643.643 0 1 0 0-1.286H3.86a2.572 2.572 0 0 1 0-5.143.643.643 0 0 0 .643-.643 1.286 1.286 0 0 1 2.185-.916.643.643 0 0 0 1.086-.355 3.854 3.854 0 1 1 7.522 1.635.643.643 0 0 0 .266.708 2.572 2.572 0 0 1-1.416 4.714h-1.929a.643.643 0 1 0 0 1.286h1.93a3.857 3.857 0 0 0 2.486-6.803z"/></g></g></g><g><g><g><path fill="url(#yh9yb)" d="M13.31 9.183l-3.215-3.215a.643.643 0 0 0-.91 0L5.97 9.183a.643.643 0 0 0 .91.909l2.118-2.117v9.377a.643.643 0 1 0 1.286 0V7.975l2.117 2.117a.643.643 0 0 0 .909-.91z"/></g></g></g></g></g></svg>
              Upload
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="full-w">
      <div class="ops__tables">
        <b-row>
          <b-col cols="12">
            <b-card-group class="table-custom cases-table">
              <b-card no-body class="fixedHeader">
                <div class="table-custom__header" slot="header">
                  <div class="tableFixedHeader">
                    <div v-if="tableHeader && item.w" class="tableFixedHeaderItem" v-for="(item, i) of tableHeader" :style="{width: `${item.w}px`}" @click="() => sort(i, item.label)">
                      {{ item.label }} <div class="tableFixedHeaderArrow"  :class="i === sortBy.i ? (!sortBy.s ? '' : sortBy.s === 1 ? 'up' : 'down') : ''" />
                    </div>
                  </div>
                </div>
                <b-table responsive show-empty small striped
                         :tbody-tr-class="totVariant"
                         thead-tr-class="text-nowrap small"
                         :busy="current_week_table_busy"
                         :items="filteredReports"
                         :fields="fields_cases">
                  <template slot="empty" slot-scope="scope">
                    <h4 class="text-center">No data available</h4>
                  </template>
                  <template slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </template>
                </b-table>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
      </div>
    </div>
    <div class="upload-popup" v-if="uploadDialog">
      <div class="popup-body">
        <span class="close-popup" @click="uploadDialog = false"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.43 17.071L12.359 9.99998L19.43 2.92891C19.7426 2.61635 19.9182 2.19243 19.9182 1.7504C19.9182 1.30837 19.7426 0.88445 19.43 0.57189C19.1175 0.259329 18.6936 0.0837345 18.2515 0.0837349C17.8095 0.0837346 17.3856 0.259329 17.073 0.571889L10.002 7.64296L2.93089 0.571889C2.61832 0.259328 2.1944 0.0837339 1.75237 0.0837342C1.31035 0.0837338 0.886423 0.259329 0.573862 0.571889C0.261302 0.884449 0.0857072 1.30837 0.0857075 1.7504C0.0857072 2.19243 0.261301 2.61635 0.573862 2.92891L7.64493 9.99998L0.573861 17.071C0.261301 17.3836 0.0857053 17.8075 0.0857053 18.2496C0.0857059 18.6916 0.261301 19.1155 0.573862 19.4281C0.886422 19.7406 1.31034 19.9162 1.75237 19.9162C2.1944 19.9162 2.61832 19.7406 2.93088 19.4281L10.002 12.357L17.073 19.4281C17.3856 19.7406 17.8095 19.9162 18.2515 19.9162C18.6936 19.9162 19.1175 19.7406 19.43 19.4281C19.7426 19.1155 19.9182 18.6916 19.9182 18.2496C19.9182 17.8075 19.7426 17.3836 19.43 17.071Z" fill="black"></path></svg></span>
        <Upload />
      </div>
    </div>
  </div>
</template>

<script>

  import Upload from './Upload/index'

  const qs = require('qs');
  export default {
    name: 'Regions',
    components: {
      Upload,
    },
    computed: {
      filteredReports: function () {
        const data = [...this.reports];
        const field = this.sortBy.field;
        if (!field) {
          return this.reports;
        }

        let fieldType;

        this.reports.forEach(item => {
          if (item[field] && typeof this.reports[0][field] === 'number') {
            fieldType = true;
            return;
          }
        });

        if(fieldType) {
          data.sort((a, b) => {
            if (!a[field] || !b[field]) {
              return a;
            }
            return a[field] - b[field];
          });
          if (this.sortBy.s === 2) {
            return [...data.reverse()];
          } else if (this.sortBy.s === 0) {
            return this.reports;
          }
          return [...data];
        }

        data.sort((a, b) => {
          if (!a[field]) {
            a[field] = '';
          }
          if (!b[field]) {
            b[field] = '';
          }
          return a[field].toString().localeCompare(b[field].toString())
        });
        if (this.sortBy.s === 2) {
          return data.reverse();
        } else if (this.sortBy.s === 0) {
          return this.reports;
        }
        return data;
      }
    },
    data: function () {
      return {
        sortBy: {
          field: '',
          s: 0,
          i: null
        },
        tableHeader: null,
        activeTab: 4,
        reports: [],
        current_week_table_busy: true,
        fields_cases: [
          {key: 'zipcode', label: 'Zip code'},
          {key: 'city', label: 'City'},
          {key: 'county', label: 'County'},
          {key: 'area', label: 'Area'},
          {key: 'region', label: 'Region'},
          {key: 'lat', label: 'Lat'},
          {key: 'lon', label: 'Lon'},
          {key: 'active', label: 'Active'},
        ],
        uploadDialog: false,
      }
    },
    async mounted() {
      this.renderHeader();
      await this.getData();
    },
    methods: {
      sort(i, field) {
        this.sortBy.i = i;

        for(let i of this.fields_cases) {
          if (i.label === field) {
            this.sortBy.field = i.key;
            break;
          }
        }

        if (this.sortBy.s < 2) {
          this.sortBy = {...this.sortBy, s: this.sortBy.s + 1}
        } else {
          this.sortBy = {...this.sortBy, s: 0}
        }
      },
      async getData() {
          this.current_week_table_busy = true;
          const endpoint = `/zipcodes?inactive=true`;
          try {
              const res = await this.$newpetehealthapi.get(endpoint, {
                  paramsSerializer: params => {
                      return qs.stringify(params)
                  }
              });

              this.reports = res.data;
              this.current_week_table_busy = false;
              this.sortBy = {
                  field: '',
                  s: 0,
                  i: 0
              };
              this.renderHeader();
          } catch (e) {
              return null;
          }
      },
      renderHeader() {
        setTimeout(() => {
          const data = [];
          const item = document.querySelector('thead tr').children;
          for (let i = 0; i < item.length; i++) {
            data.push({w: item[i].clientWidth, label: item[i].innerText});
          }

          this.tableHeader = data;
        });
      },
      totVariant(c) {
        if (c == undefined) return
        let classStr = "text-nowrap"; // Default classes
        let cName = c.therapist || c.region ||'';
        if (cName.match(/Total/))
          classStr += ' bg-dark';
        else if (cName.match(/Subtotal/))
          classStr += ' text-dark bg-primary';

        if (c.status) {
          if (c.status === 'On Hold')
            classStr += ' row-blue';
          else if (((c.visits + c.scheduled) > parseInt(c.total_prescribed_visits)) &&
            (c.insurance != 'NONE'))
            classStr += ' row-red';
          else if (c.scheduled < 2)
            classStr += ' row-yellow';
        }
        return classStr;
      },
      getDataAsCSV() {
        const baseURL = (process.env.VUE_APP_RUBY_URL || 'https://devopstest.petehealth.com:8080') + '/api/zipcodes';
        const params = {inactive: true, csv: true };
        let endpoint = `${baseURL}`;
        const filename = 'report.csv';

        this.$newpetehealthapi.get(endpoint, {
          params: params,
          paramsSerializer: params => {
            return qs.stringify(params)
          }
        }).then( (r) => {
          const url = window.URL.createObjectURL(new Blob([r.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        })
      },
    },
  }
</script>

<style lang="scss">
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
  table.b-table[aria-busy='true'] {
    opacity: 0.4;
  }
  .formatlastrow tr:last-child {
    border-top: double;
  }

  .tableFixedHeader {
    display: flex;
    background-color: #eff0f2;
    margin: 0 -20px;
    &Arrow {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 15px;
      cursor: pointer;
      margin-right: -4px;
      &.up {
        &:before {
          border-bottom: 5px solid #46505c;
        }
      }
      &.down {
        &:after {
          border-top: 5px solid #46505c;
        }
      }
      &:before {
        display: block;
        content: "";
        border: 4px solid transparent;
        border-bottom: 5px solid #73818f;
        margin-bottom: 3px;
        transition: .3s;
      }
      &:after {
        display: block;
        content: "";
        border: 4px solid transparent;
        border-top: 5px solid #73818f;
        transition: .3s;
      }
    }
  }
  .tableFixedHeaderItem {
    height: 47px;
    display: flex;
    align-items: center;
    overflow: hidden;
    font-size: 14px;
    color: rgba(0, 35, 78, 0.6);
    font-weight: bold;
    padding: 0 .3rem;
    cursor: pointer;
    &:first-child {
       padding: 0 20px;
     }
  }
  .no-wrap {
    white-space: nowrap;
  }

  .full-w {
    width: 100%;
    max-width: calc(1920px - 30px);
    margin: 0 auto;
  }
  .ops__header {
    margin-bottom: 20px;
  }
  .popup-body {
    max-height: 90vh;
    max-width: 970px;
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    height: auto;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 10px 20px rgba(36,16,129,.05);
    z-index: 99999;
    .close-popup {
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
      z-index: 99999;
    }
  }
  .table-custom .fixedHeader .table-responsive {
    max-height: calc(100vh - 270px);
  }
</style>
